import React, { useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { CONTAINER } from "./parts";

const NAV = [
  { to: "/services/data-analytics-ai", label: "Data & AI" },
  { to: "/services/industrial-intelligence", label: "Industrial" },
  { to: "/services/agricultural-technology", label: "Agri-tech" },
  { to: "/services/custom-software", label: "Software" },
  { to: "/solutions/dairy", label: "Dairy" },
  { to: "/about", label: "About" },
];

const linkClass = ({ isActive }) =>
  `text-sm py-2 ${isActive ? "text-accent-600 font-semibold" : "text-ink-500 hover:text-accent-600"}`;

export default function MarketingLayout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen bg-white text-ink-900 font-sans">
      <header className="sticky top-0 z-40 bg-white border-b border-paper-200">
        <div className={`${CONTAINER} h-16 flex items-center justify-between`}>
          <Link to="/" className="text-lg font-semibold tracking-tight">
            Neuracraft
          </Link>
          <nav aria-label="Primary" className="hidden lg:flex items-center gap-6">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} className={linkClass}>
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="hidden lg:flex items-center gap-4">
            <Link
              to="/contact"
              className="text-sm px-4 py-2 bg-ink-900 text-white rounded hover:bg-ink-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent-600"
            >
              Discuss a project
            </Link>
          </div>
          <button
            type="button"
            className="lg:hidden p-2"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            aria-controls="mobile-nav"
            onClick={() => setOpen(!open)}
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
        {open && (
          <nav id="mobile-nav" aria-label="Mobile" className="lg:hidden border-t border-paper-200 px-4 py-3 flex flex-col">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} className={linkClass} onClick={() => setOpen(false)}>
                {n.label}
              </NavLink>
            ))}
            <Link to="/contact" className="text-sm py-2 font-semibold" onClick={() => setOpen(false)}>
              Discuss a project
            </Link>
          </nav>
        )}
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="bg-ink-900 text-ink-300">
        <div className={`${CONTAINER} py-12 grid gap-8 sm:grid-cols-3 text-sm`}>
          <div>
            <p className="text-white font-semibold mb-2">Neuracraft</p>
            <p>Nairobi, Kenya</p>
            <p>P.O Box 74494-00200, Commercial Street, Nairobi</p>
            <a className="underline hover:text-accent-300" href="mailto:info@neuracraft.co.ke">
              info@neuracraft.co.ke
            </a>
          </div>
          <div className="flex flex-col gap-1">
            <p className="text-white font-semibold mb-2">Services</p>
            {NAV.slice(0, 5).map((n) => (
              <Link key={n.to} to={n.to} className="hover:text-accent-300">
                {n.label}
              </Link>
            ))}
          </div>
          <div className="flex flex-col gap-1">
            <p className="text-white font-semibold mb-2">Company</p>
            <Link to="/about" className="hover:text-accent-300">About</Link>
            <Link to="/contact" className="hover:text-accent-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
